import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { Vista } from './components/Vistas';

const VentasCortesiasReporte: FC = () => {
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '/reportes/ventas-cortesias',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Reporte de Ventas con Cortesías</PageTitle>
      <Vista />
    </>
  );
};

export { VentasCortesiasReporte };
